export default __webpack_public_path__ + "media/images/delete2_disabled-7026daeffed5abe7230e4686e1bf0d73.png";